import React from "react";

const PlanManagement = () => {
  return <>PlanManagement</>;
};

export default PlanManagement;
